 export const betsMap: { [key: string]: any } = {
    'bets': {
        "_id": {
          "$oid": "65a7ae7faa083cf8f2383421"
        },
        "event_key": "SportRadar-sr:sport:1-sr:match:46958579",
        "operator_id": "hypexexchfeature01",
        "partner_id": "HEPID01",
        "token": "7f0ea757-5ba6-4331-b476-d72e6843d431",
        "provider_id": "SportRadar",
        "sport_id": "sr:sport:1",
        "competition_id": "sr:tournament:853",
        "user_id": "zdemo20",
        "user_name": "zdemo20",
        "event_id": "sr:match:46958579",
        "market_id": "12",
        "transaction_id": "5ebc75df-12f3-47d8-a503-1343656fea3a",
        "net_amount": 129,
        "settlement_status": "SETTLED",
        "status": "SETTLED",
        "created_at": "1705487994439",
        "updated_at": "1705488190243",
      },
    'markets' : {
        "_id": {
          "$oid": "65a9feb5563163f572851e73"
        },
        "market_key": "SportRadar-sr:sport:5-sr:match:47060351-186",
        "event_key": "SportRadar-sr:sport:5-sr:match:47060351",
        "provider_id": "SportRadar",
        "provider_name": "SportRadar",
        "sport_id": "sr:sport:5",
        "sport_name": "Tennis",
        "competition_id": "sr:tournament:2575",
        "competition_name": "Australian Open Mixed Doubles",
        "event_id": "sr:match:47060351",
        "event_name": "Purcell M / Rodionova Ar vs. Gille S / Siegemund L",
        "market_id": "186",
        "market_name": "Winner",
        "market_type": "MATCH_ODDS",
        "status": "ACTIVE",
        "created_at": "1705639605",
        "updated_at": "1705644309",
        "market_status": "SETTLED",
      },
    'events' : {
        "_id": {
          "$oid": "65ae5854f2942d19435138a0"
        },
        "event_key": "SportRadar-sr:sport:1-sr:match:42430255",
        "provider_id": "SportRadar",
        "provider_name": "SportRadar",
        "sport_id": "sr:sport:1",
        "sport_name": "Soccer",
        "competition_id": "sr:tournament:34834",
        "competition_name": "Primera Federacion",
        "event_id": "sr:match:42430255",
        "event_name": "CF Fuenlabrada vs. FC Barcelona Atletic",
        "open_date": "1706463000000",
        "status": "ACTIVE",
        "event_status": "UPCOMING",
        "created_at": "1705924692",
        "updated_at": "1705924692",
      }
  };